<template>
  <div>
    <!-- Header -->
    <div class="header py-7 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <!-- Page content -->
    <b-container class="mt--9 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <h1>Welcome!</h1>
                <h2>Login</h2>
                <small>Don't have an account? Then please <a href="/register">Register Now</a></small>
              </div>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input alternative
                              class="mb-3"
                              name="Email"
                              :rules="{required: true, email: true}"
                              prepend-icon="ni ni-email-83"
                              placeholder="Email"
                              v-model="email">
                  </base-input>
                  <validation-error :errors="apiValidationErrors.email" />

                  <base-input alternative
                              class="mb-3"
                              name="Password"
                              :rules="{required: true, min: 6}"
                              prepend-icon="ni ni-lock-circle-open"
                              type="password"
                              placeholder="Password"
                              v-model="password">
                  </base-input>
                  <validation-error :errors="apiValidationErrors.password" />

                  <div class="text-center">
                    <base-button type="danger" native-type="submit" class="my-4" :disabled="submitted">{{ submitBtn }}</base-button>
                  </div>
                </b-form>
              </validation-observer>
              <b-row class="mt-3">
                <b-col cols="6">
                  <router-link to="/forgot-password" class="text-dark"><small>Forgot password?</small></router-link>
                </b-col>
                <b-col cols="6" class="text-right">
                  <router-link to="/register" class="text-dark"><small>Create new account</small></router-link>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";

export default {
  components: {
    ValidationError,
  },
  mixins: [formMixin],
  data: () => ({
    email: "",
    password: "",
    year: new Date().getFullYear(),
    submitted: false,
  }),
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated();
    },
    user() {
      return this.$store.getters['profile/user'];
    },
    submitBtn() {
      return this.submitted ? 'Processing...' : 'Sign in';
    }
  },
  methods: {
    async onSubmit() {
      this.submitted = true;
      const user = {
        email: this.email,
        password: this.password
      };

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };

      try {
        await this.$store.dispatch("login", { user, requestOptions });
        await this.$store.dispatch("roles/get");
        await this.$store.dispatch("teams/get", {user: this.user.slug});
        await this.$router.push({ path: "/home" });
        
      } catch (error) {
        this.submitted = false;
        swal.fire({
          title: `Error`,
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 3000,
          icon: 'error'
        });
      }
    }
  },
};
</script>

